import { useState } from 'react';

import { FormForgot } from './FormForgot';
import { FormLogin } from './FormLogin';
import './styles.scss';

export const Login = () => {
	const [smt, setSmt] = useState(false);
	const [type, setType] = useState('login');

	return (
		<main className="wrap login">
			{type === 'login' && (
				<FormLogin smt={smt} setSmt={setSmt} setType={setType} />
			)}
			{type === 'forgot' && <FormForgot back={setType} />}
		</main>
	);
};
